import { changeContainerSizeDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getchangeContainerSizeEn = () => {
  const data = changeContainerSizeDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addchangeContainerSize = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-can-i-change-my-container-size`,
    ) &&
    document.getElementById(`changeContainerSizeJSONLD`) === null
  ) {
    const script = changeContainerSizeJSONLDEn()
    addJSONLDToHead(script, `changeContainerSizeJSONLD`)
  } else {
    removeElement(`changeContainerSizeJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const changeContainerSizeJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getchangeContainerSizeEn(),
  }
  return FaqBagsterTemplate
}
